module.exports = __webpack_public_path__ + "static/media/utility-bill.0731be12.svg";